<div class="col-12 logocontainer">
    <div class="logo">
      <img src="assets/images/logo.png" class="img-fluid">
    </div>
    <div class="outer_circle">
        <div class="inner_circle">
  
        </div>
      </div>
</div>